/**
 * Tovar — položky cenníka obchodu (KOLO 230): regály CRC, neskôr Giussani.
 *
 * Kam položka patrí, rozhoduje backend (`services/cennik_sekcie`, sekcia
 * `tovar`); tu sú len pomôcky na zobrazenie. Pravidlá objednania CRC
 * (`docs/domena/CRC_REGALY.md` kap. 7.9): pri povrchu **CO** sa volí farba
 * zo 49 farieb CRC, ostatné povrchy (BC biela, PB plast, GR surový…) majú
 * farbu pevnú. Kartu ABRY s farbou (`0719/COA9`) skladá server
 * (`DielecResponse.karta_abry`).
 */

/** Povrch, pri ktorom sa farba volí. */
export const POVRCH_FARBA = "CO";

type MaterialTovaru = {
  tovar_kod?: string | null;
  tovar_povrch?: string | null;
  vyrobca?: string | null;
  supplier_data?: Record<string, unknown> | null;
};

/** Položka cenníka tovaru (má kód tovaru). */
export function jeTovar(m: MaterialTovaru | null | undefined): boolean {
  return Boolean(m?.tovar_kod);
}

/** Pri položke sa volí farba — tovar s povrchom CO. */
export function volitFarbu(m: MaterialTovaru | null | undefined): boolean {
  return jeTovar(m) && (m?.tovar_povrch ?? "").trim().toUpperCase() === POVRCH_FARBA;
}

/** Karta ABRY bez farby (`0210/CO`) zo `supplier_data` importu CRC. */
export function kartaAbryMaterialu(m: MaterialTovaru | null | undefined): string | null {
  const karta = m?.supplier_data?.["kod_abry"];
  return typeof karta === "string" && karta.trim() ? karta.trim() : null;
}

/**
 * Druhý riadok položky tovaru v Cenníku a vo výbere: „povrch CO · ABRA
 * 0210/CO · CRC". Tri „Konzola 20" sa líšia len povrchom (CO, GR, BC),
 * preto je povrch vždy; karta ABRY len keď nie je to isté ako kód (starý
 * kód CRC je karta ABRY — `17118/CO`).
 */
export function podnazovTovaru(m: MaterialTovaru | null | undefined): string {
  const kod = (m?.tovar_kod ?? "").trim().toUpperCase();
  const karta = kartaAbryMaterialu(m);
  const povrch = (m?.tovar_povrch ?? "").trim();
  return [
    povrch ? `povrch ${povrch}` : null,
    karta && karta.toUpperCase() !== kod ? `ABRA ${karta}` : null,
    m?.vyrobca?.trim() || null,
  ]
    .filter(Boolean)
    .join(" · ");
}

/** „CO A9", „CO — doplň farbu", „BC" — povrch a farba do riadku. */
export function popisPovrchu(
  m: MaterialTovaru | null | undefined,
  farba: string | null | undefined,
): string | null {
  if (!jeTovar(m)) return null;
  const povrch = (m?.tovar_povrch ?? "").trim();
  if (volitFarbu(m)) {
    const f = (farba ?? "").trim().toUpperCase();
    return f ? `${povrch} ${f}` : `${povrch} — doplň farbu`;
  }
  return povrch || null;
}
